import { useFormContext } from "react-hook-form";
import PhoneInput from "./PhoneInput";
import { CustomButton } from "./CustomButton";
import { useTranslate } from "react-admin";

const CheckUserByPhoneNumber = ({
  checkFunction,
  userId,
  isCustomerSearchTriggered,
  setIsCustomerSearchTriggered
}: any) => {
  const translate = useTranslate();
  const form = useFormContext();
  const phoneNumberState = form?.watch("phone_number_search");

  return (
    <div className="w-full">
      <div className="w-full flex gap-2">
        <PhoneInput source="phone_number_search" fullWidth checkSubmitted />
        <div className="flex h-[49px] items-center">
          <CustomButton
            variant="tertiary"
            type="button"
            text={translate("appointment.search")}
            onClick={() => {
              if (!phoneNumberState) return;
              checkFunction(phoneNumberState);
              setTimeout(() => {
                setIsCustomerSearchTriggered(true);
              }, 1000);
            }}
          />
        </div>
      </div>
      {!userId && isCustomerSearchTriggered && (
        <div className="mb-3 text-[#EF5B1B]">Customer not found</div>
      )}
    </div>
  );
};

export default CheckUserByPhoneNumber;
